export default __webpack_public_path__ + "static/media/apkDown.90c7fe9e.png";